export interface NewsCategory {
  slug: string;
  name: string;
  shortName: string;
  icon: string;
  description: string;
  longDescription: string;
  cover: string;
  accent: 'primary' | 'accent' | 'secondary';
  keywords: string[];
  count: number;
  updatedAt: string;
}

export const categories: NewsCategory[] = [
  {
    slug: 'entertainment',
    name: '娱乐八卦',
    shortName: '娱乐',
    icon: 'ri-vip-crown-2-line',
    description: '明星动态、合作与合约，第一时间梳理事件脉络。',
    longDescription:
      '娱乐八卦栏目关注演出、合作、合约与公开回应等公共信息，把零散的爆料按时间顺序重新排列，帮助你在三分钟内看懂一件事的来龙去脉，而不是被碎片化的截图带着走。',
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20a%20stage%20spotlight%20with%20soft%20film%20grain%2C%20warm%20watermelon%20coral%20red%20and%20amber%20gradient%20shapes%2C%20minimal%20geometric%20composition%2C%20muted%20cream%20background%2C%20magazine%20aesthetic%2C%20high%20detail&width=900&height=640&seq=gua-cat-01&orientation=landscape',
    accent: 'primary',
    keywords: ['明星动态', '演出合作', '合约纠纷'],
    count: 128,
    updatedAt: '10 分钟前',
  },
  {
    slug: 'influencer',
    name: '网红动态',
    shortName: '网红',
    icon: 'ri-live-line',
    description: '直播圈、短视频达人的涨粉、合作与争议现场。',
    longDescription:
      '网红动态栏目覆盖短视频与直播行业的热门话题，包括账号运营、内容合作、粉丝增长与商业纠纷。我们更关心事件背后的规则变化，而不是单纯的站队。',
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20a%20ring%20light%20and%20smartphone%20silhouette%20with%20soft%20film%20grain%2C%20warm%20coral%20red%20and%20amber%20gradient%20shapes%2C%20minimal%20geometric%20composition%2C%20muted%20cream%20background%2C%20magazine%20aesthetic&width=900&height=640&seq=gua-cat-02&orientation=landscape',
    accent: 'secondary',
    keywords: ['直播带货', '短视频', '粉丝增长'],
    count: 96,
    updatedAt: '25 分钟前',
  },
  {
    slug: 'screen',
    name: '影视综艺',
    shortName: '影视',
    icon: 'ri-movie-2-line',
    description: '剧集口碑、综艺名场面与选角话题的完整复盘。',
    longDescription:
      '影视综艺栏目聚焦剧集与综艺的播出反馈、口碑分化与幕后讨论，整理观众争议的焦点问题，也记录制作方的公开回应，让讨论回到作品本身。',
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20a%20film%20clapperboard%20and%20reel%20with%20soft%20film%20grain%2C%20warm%20coral%20red%20and%20amber%20gradient%20shapes%2C%20minimal%20geometric%20composition%2C%20muted%20cream%20background%2C%20magazine%20aesthetic&width=900&height=640&seq=gua-cat-03&orientation=landscape',
    accent: 'accent',
    keywords: ['剧集口碑', '综艺名场面', '选角'],
    count: 142,
    updatedAt: '42 分钟前',
  },
  {
    slug: 'social',
    name: '社会热议',
    shortName: '社会',
    icon: 'ri-chat-smile-2-line',
    description: '公共话题与网络现象，评论区里的真实情绪。',
    longDescription:
      '社会热议栏目关注在网络上被高频讨论的公共话题与生活现象。我们把不同立场的声音并列呈现，标注信息来源与时间，尽量避免情绪化的单向结论。',
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20overlapping%20speech%20bubbles%20with%20soft%20film%20grain%2C%20warm%20coral%20red%20and%20amber%20gradient%20shapes%2C%20minimal%20geometric%20composition%2C%20muted%20cream%20background%2C%20magazine%20aesthetic&width=900&height=640&seq=gua-cat-04&orientation=landscape',
    accent: 'secondary',
    keywords: ['公共话题', '网络现象', '职场讨论'],
    count: 78,
    updatedAt: '1 小时前',
  },
  {
    slug: 'brand',
    name: '品牌风向',
    shortName: '品牌',
    icon: 'ri-store-2-line',
    description: '营销活动、代言合作与消费舆情的来龙去脉。',
    longDescription:
      '品牌风向栏目整理品牌营销、联名合作与消费舆情的公开信息，还原从创意发布到官方回应的完整过程，帮你看懂一次传播为什么会走向失控或爆红。',
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20shopping%20tags%20and%20geometric%20packaging%20blocks%20with%20soft%20film%20grain%2C%20warm%20coral%20red%20and%20amber%20gradient%20shapes%2C%20minimal%20composition%2C%20muted%20cream%20background&width=900&height=640&seq=gua-cat-05&orientation=landscape',
    accent: 'primary',
    keywords: ['营销活动', '代言合作', '消费舆情'],
    count: 64,
    updatedAt: '2 小时前',
  },
  {
    slug: 'life',
    name: '情感生活',
    shortName: '情感',
    icon: 'ri-heart-3-line',
    description: '婚恋、情感与生活方式话题的多元观点。',
    longDescription:
      '情感生活栏目聊的是日常里那些反复被提起的议题：亲密关系、择偶标准、家庭沟通与生活选择。我们不做情感导师，只把更多真实的经验与观点摆出来供你参考。',
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20two%20interlocking%20soft%20abstract%20shapes%20with%20film%20grain%2C%20warm%20coral%20red%20and%20amber%20gradient%20tones%2C%20minimal%20geometric%20composition%2C%20muted%20cream%20background%2C%20magazine%20aesthetic&width=900&height=640&seq=gua-cat-06&orientation=landscape',
    accent: 'accent',
    keywords: ['情感话题', '婚恋讨论', '生活方式'],
    count: 52,
    updatedAt: '3 小时前',
  },
];

